import useAPI from '@/hooks/useAPI';
import PersonChallengeRepository, {
  type PersonChallengeParams
} from '@/repositories/PersonChallengeRepository';

export const usePersonChallengesByIdPaginated = (
  params: PersonChallengeParams,
  personId: string
) => {
  const repository = PersonChallengeRepository();

  return useAPI({
    queryKey: ['getPersonChallengesListByIdPaginated', personId, params],
    queryFn: async () => {
      return await repository.listByIdPaginated({ id: personId, ...params });
    },
    enabled: !!personId
  });
};
